import { get, post, put, del } from "@crunchit/http-client";
import { IBasketDto, IBasketItemDto, IBasketProductRequestBody } from "@crunchit/types";
import { getToken, getEnvironment } from "utils/helpers/service";

const api = process.env.REACT_APP_BASKET_URI || `basket.${getEnvironment()}crunchy.ninja/api`;

const BasketService = {
  getNewBasket: async () => {
    return get<IBasketDto>(`${api}/basket`, getToken());
  },
  getBasketById: async (id: string) => {
    return get<IBasketDto>(`${api}/basket/${id}`, getToken());
  },
  addProductToBasket: async (basketId: string, product: IBasketProductRequestBody) => {
    return post<IBasketDto>(`${api}/basket/${basketId}/products`, product, getToken());
  },
  updateBasketItem: async (basketId: string, basketProductId: string, basketItem: IBasketItemDto) => {
    return put<IBasketDto>(`${api}/basket/${basketId}/products/${basketProductId}`, basketItem, getToken());
  },
  removeBasketItem: async (basketId: string, basketProductId: string) => {
    return del<IBasketDto>(`${api}/basket/${basketId}/products/${basketProductId}`, getToken());
  },
};

export default BasketService;
